(function () {
  'use strict';

  var _s = window.__ddCartShared = window.__ddCartShared || {};
  var _queue = [];
  var _processing = false;
  var _activeJob = null;
  var _latestCartData = null;
  var _freshCartInflight = null;
  var _freshCartTs = 0;
  var _cartRevision = 0;
  var DEFAULT_CART_CACHE_TTL = 5000;

  var _metrics = {
    startedAt: new Date().toISOString(),
    requestsTotal: 0,
    requestsByEndpoint: {},
    requestsByAction: {},
    recentRequests: [],
    drawerPatchSuccess: 0,
    drawerPatchFail: 0,
    drawerFullReplaceFallback: 0,
    queueDrops: 0,
    coalescedByKey: {},
    coalescedByAction: {}
  };
  window.__ddCartMetrics = _metrics;

  function paint() { return window._ddCartPaint || {}; }
  function notify() { return window._ddCartNotify || {}; }
  function facade() { return window.ddCartHelpers || {}; }

  function recordRequest(endpoint, action, source) {
    var ep = String(endpoint || 'unknown');
    var act = String(action || 'unknown');
    var src = String(source || 'unknown');
    _metrics.requestsTotal += 1;
    _metrics.requestsByEndpoint[ep] = (_metrics.requestsByEndpoint[ep] || 0) + 1;
    _metrics.requestsByAction[act] = (_metrics.requestsByAction[act] || 0) + 1;
    _metrics.recentRequests.push({ t: new Date().toISOString(), endpoint: ep, action: act, source: src });
    if (_metrics.recentRequests.length > 80) _metrics.recentRequests.shift();
  }

  function isDebugEnabled() { return !!window.__ddCartDebug; }

  function debugLog(eventName, payload) {
    if (!isDebugEnabled()) return;
    try { console.info('[dd-cart-debug]', eventName, payload || {}); } catch (_) {}
  }

  function hasAuthoritativeCartShape(cart) {
    return !!(cart && typeof cart.item_count === 'number' && Array.isArray(cart.items));
  }

  function invalidateFreshCartCache(opts) {
    _freshCartTs = 0;
    _cartRevision += 1;
    if (opts && opts.clearLatest) _latestCartData = null;
  }

  function markCartFresh(cart) {
    if (!hasAuthoritativeCartShape(cart)) return false;
    _latestCartData = cart;
    _freshCartTs = Date.now();
    _cartRevision += 1;
    return true;
  }

  function getLatestCart() { return _latestCartData; }

  function seedLatestCart(cart) { markCartFresh(cart); }

  function getDefaultSections() {
    var isCartPage = /\/cart\b/.test(window.location.pathname);
    if (isCartPage) {
      var secs = ['cart-icon-bubble'];
      var el1 = document.getElementById('main-cart-items');
      var el2 = document.getElementById('main-cart-footer');
      if (el1 && el1.dataset.id) secs.push(el1.dataset.id);
      if (el2 && el2.dataset.id) secs.push(el2.dataset.id);
      return secs;
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function sectionsFromMutationJob(job) {
    if (!job || !job.body || typeof job.body !== 'object') return [];
    var p = paint();
    return p.normalizeSectionList ? p.normalizeSectionList(job.body.sections) : [];
  }

  function isLineChangeJob(job) {
    if (!job || !job.body || typeof job.body !== 'object') return false;
    if (String(job.endpoint || '').indexOf('/cart/change.js') === -1) return false;
    if (typeof job.body.quantity !== 'number') return false;
    if (typeof job.body.id === 'string' && job.body.id.trim()) return true;
    var line = parseInt(job.body.line, 10);
    return !!(line && line > 0);
  }

  function resolveLineIdentity(body, cart) {
    if (!body || !cart || !Array.isArray(cart.items)) return;
    var items = cart.items;
    if ((!body.id || typeof body.id !== 'string' || !body.id.trim()) && body.line) {
      var currentLine = parseInt(body.line, 10);
      if (currentLine > 0 && items[currentLine - 1] && items[currentLine - 1].key) {
        body.id = items[currentLine - 1].key;
        if (Object.prototype.hasOwnProperty.call(body, 'line')) { try { delete body.line; } catch (_) { body.line = undefined; } }
        return;
      }
      return;
    }
    if (typeof body.id !== 'string' || !body.id.trim()) return;
    var originalKey = body.id;
    for (var i = 0; i < items.length; i++) {
      if (items[i].key === originalKey) {
        if (Object.prototype.hasOwnProperty.call(body, 'line')) { try { delete body.line; } catch (_) { body.line = undefined; } }
        return;
      }
    }
    var colonIdx = originalKey.indexOf(':');
    var variantId = colonIdx > 0 ? originalKey.substring(0, colonIdx) : originalKey;
    var propsHash = colonIdx > 0 ? originalKey.substring(colonIdx + 1) : '';
    var matches = [];
    for (var j = 0; j < items.length; j++) {
      if (String(items[j].variant_id) === variantId) matches.push({ item: items[j], line: j + 1 });
    }
    if (matches.length === 0) return;
    var pick = matches[0];
    if (matches.length > 1 && propsHash) {
      var hashFound = false;
      for (var k = 0; k < matches.length; k++) {
        var mKey = matches[k].item.key || '';
        var mColonIdx = mKey.indexOf(':');
        var mHash = mColonIdx > 0 ? mKey.substring(mColonIdx + 1) : '';
        if (mHash === propsHash) { pick = matches[k]; hashFound = true; break; }
      }
      if (!hashFound) {
        for (var pp = 0; pp < matches.length; pp++) {
          if ((matches[pp].item.price || 0) > (pick.item.price || 0)) pick = matches[pp];
        }
      }
    }
    body.id = pick.item.key;
    if (Object.prototype.hasOwnProperty.call(body, 'line')) { try { delete body.line; } catch (_) { body.line = undefined; } }
  }

  function sleep(ms) { return new Promise(function (resolve) { window.setTimeout(resolve, ms); }); }

  function isRateLimitError(err) {
    if (!err) return false;
    var status = Number(
      (err.shopifyStatus || err.status) ||
      (err.responseBody && err.responseBody.status) ||
      0
    );
    if (status === 429) return true;
    var raw = '';
    if (err.description) raw += String(err.description) + ' ';
    if (err.message) raw += String(err.message);
    raw = raw.toLowerCase();
    return /(^|\b)(1015|429)(\b|$)|rate\s*limit|too\s+many\s+requests/.test(raw);
  }

  function performQueuedMutation(job, attempt) {
    var retry = typeof attempt === 'number' ? attempt : 0;
    recordRequest(job.endpoint, job.opts && job.opts.action ? job.opts.action : 'cart-mutate', retry > 0 ? 'queue-retry' : 'queue');
    return fetch(job.endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(job.body)
    }).then(function (r) {
      if (r.status === 429 && retry < 2) {
        return sleep(650 * (retry + 1)).then(function () { return performQueuedMutation(job, retry + 1); });
      }
      if (!r.ok) {
        return r.json().catch(function () { return {}; }).then(function (body) {
          var message = (body && (body.description || body.message)) || 'Cart mutation failed (' + r.status + ')';
          var err = new Error(message);
          err.shopifyStatus = r.status;
          err.description = body && (body.description || body.message) ? (body.description || body.message) : '';
          err.responseBody = body;
          throw err;
        });
      }
      return r.json();
    });
  }

  function processQueue() {
    if (_processing || !_queue.length) return;
    _processing = true;
    var job = _queue.shift();
    _activeJob = job;
    debugLog('queue:dequeue', {
      type: job.type || 'mutation',
      endpoint: job.endpoint || null,
      action: (job.opts && job.opts.action) || job.action || job.label || 'cart-mutate',
      remaining: _queue.length
    });

    if (job.type === 'external') { performExternalMutation(job); return; }

    if (isLineChangeJob(job) && _latestCartData && Array.isArray(_latestCartData.items)) {
      resolveLineIdentity(job.body, _latestCartData);
    }

    var p = paint();
    var n = notify();
    var replaceCartSections = p.replaceCartSections || function () {};
    var fetchSectionsFallback = p.fetchSectionsFallback || function () { return Promise.resolve(null); };
    var publishCartUpdate = n.publishCartUpdate || function () {};

    performQueuedMutation(job, 0)
      .then(function (data) {
        if (!markCartFresh(data)) invalidateFreshCartCache({ clearLatest: true });
        var shouldReplaceSections = !(job.opts && job.opts.skipSectionReplace);
        var sectionSync = Promise.resolve(null);
        var isAddAction = String(job.endpoint || '').indexOf('/cart/add.js') !== -1;
        if (shouldReplaceSections) {
          if (data.sections) {
            replaceCartSections(data.sections, { scrollToTop: isAddAction });
          } else {
            var fallbackSections = sectionsFromMutationJob(job);
            if (fallbackSections.length) {
              sectionSync = fetchSectionsFallback(fallbackSections).then(function (sectionsPayload) {
                if (sectionsPayload) replaceCartSections(sectionsPayload, { scrollToTop: isAddAction });
              });
            } else {
              _s.granularFooterPending = false;
            }
          }
        } else {
          _s.granularFooterPending = false;
        }
        return sectionSync
          .catch(function (sectionErr) {
            _s.granularFooterPending = false;
            console.error('[cart-queue] section fallback error', sectionErr);
          })
          .then(function () {
            if (!(job.opts && job.opts.skipPublish)) publishCartUpdate(data, job.opts && job.opts.publishSource);
            job.resolve(data);
            if (Array.isArray(job.coalesced)) {
              for (var i = 0; i < job.coalesced.length; i++) {
                try { job.coalesced[i].resolve(data); } catch (e) { console.error('[cart-queue] coalesced resolve error', e); }
              }
            }
          });
      })
      .catch(function (err) {
        var meta = { endpoint: job.endpoint, action: job.opts && job.opts.action ? job.opts.action : 'cart-mutate', body: job.body };
        window.__ddLastMutationError = { at: new Date().toISOString(), endpoint: meta.endpoint, action: meta.action, body: meta.body, message: err && err.message ? err.message : String(err) };
        console.error('[cart-queue] mutation error ' + JSON.stringify(meta) + ' :: ' + (err && err.message ? err.message : String(err)));
        job.reject(err);
        if (Array.isArray(job.coalesced)) {
          for (var i = 0; i < job.coalesced.length; i++) {
            try { job.coalesced[i].reject(err); } catch (e) { console.error('[cart-queue] coalesced reject error', e); }
          }
        }
      })
      .finally(function () { _processing = false; _activeJob = null; if (_queue.length) processQueue(); });
  }

  function queueMutate(opts) {
    opts = opts || {};
    var isExternal = typeof opts.run === 'function';
    var render = opts.render;
    if (render === undefined) {
      if (opts.skipSectionReplace) render = false;
      else if (isExternal) render = false;
      else render = 'patch';
    }
    var shouldPublish = opts.publish;
    if (shouldPublish === undefined) {
      if (opts.skipPublish) shouldPublish = false;
      else if (isExternal) shouldPublish = false;
      else shouldPublish = true;
    }
    var endpoint = opts.endpoint || (isExternal ? '/cart/external' : '/cart/update.js');
    var body = opts.body || {};
    var action = opts.action || opts.label || (isExternal ? 'external-mutate' : 'cart-mutate');
    var source = opts.source || opts.publishSource || action;
    if (!isExternal) {
      var sections;
      if (Object.prototype.hasOwnProperty.call(opts, 'sections')) sections = opts.sections;
      else if (opts.includeSections === false) sections = null;
      else sections = getDefaultSections();
      if (sections && typeof body === 'object') {
        body.sections = sections;
        if (!Object.prototype.hasOwnProperty.call(body, 'sections_url')) body.sections_url = '/cart';
      }
    }
    return new Promise(function (resolve, reject) {
      var job = {
        type: isExternal ? 'external' : 'mutation',
        endpoint: endpoint,
        body: body,
        opts: { action: action, source: source, coalesceKey: opts.coalesceKey || '', render: render, publish: shouldPublish, includeSections: opts.includeSections, sections: opts.sections, skipSectionReplace: render === false, skipPublish: !shouldPublish, publishSource: source },
        resolve: resolve,
        reject: reject,
        coalesced: []
      };
      if (isExternal) {
        job.run = opts.run;
        job.label = opts.label || action;
        job.requester = opts.requester || 'external';
        job.action = action;
        job.timeoutMs = typeof opts.timeoutMs === 'number' ? opts.timeoutMs : 15000;
        job.invalidateFreshCart = opts.invalidateFreshCart !== false;
      }
      if (_processing && _activeJob && _activeJob.type === 'external') {
        debugLog('queue:enqueue-during-external', { endpoint: endpoint, action: action, activeExternal: _activeJob.action || _activeJob.label || 'external', queuedAfterPush: _queue.length + 1 });
      }
      var key = job.opts.coalesceKey;
      if (key) {
        for (var i = _queue.length - 1; i >= 0; i--) {
          var queued = _queue[i];
          var queuedKey = queued && queued.opts && typeof queued.opts.coalesceKey === 'string' ? queued.opts.coalesceKey : '';
          if (queuedKey !== key) continue;
          job.coalesced.push({ resolve: queued.resolve, reject: queued.reject });
          if (Array.isArray(queued.coalesced) && queued.coalesced.length) {
            for (var j = 0; j < queued.coalesced.length; j++) job.coalesced.push(queued.coalesced[j]);
          }
          _metrics.coalescedByKey[key] = (_metrics.coalescedByKey[key] || 0) + 1;
          _metrics.coalescedByAction[action] = (_metrics.coalescedByAction[action] || 0) + 1;
          _queue[i] = job;
          _metrics.queueDrops += 1;
          processQueue();
          return;
        }
      }
      _queue.push(job);
      processQueue();
    });
  }

  function cartMutate(endpoint, body, opts) {
    opts = opts || {};
    var queueOpts = { endpoint: endpoint, body: body, render: opts.skipSectionReplace ? false : 'patch', publish: !opts.skipPublish, coalesceKey: opts.coalesceKey, action: opts.action || 'cart-mutate', source: opts.publishSource, publishSource: opts.publishSource };
    if (Object.prototype.hasOwnProperty.call(opts, 'sections')) queueOpts.sections = opts.sections;
    if (Object.prototype.hasOwnProperty.call(opts, 'includeSections')) queueOpts.includeSections = opts.includeSections;
    return queueMutate(queueOpts);
  }

  function makeCoalesceKey(scope, id) {
    var s = String(scope || '').trim();
    if (!s) return '';
    if (id == null || id === '') return s;
    return s + ':' + String(id);
  }

  function mutateCartChange(body, opts) {
    var nextOpts = opts ? Object.assign({}, opts) : {};
    if (!nextOpts.action) nextOpts.action = 'cart-change';
    return cartMutate('/cart/change.js', body, nextOpts);
  }

  function mutateCartUpdate(body, opts) {
    var nextOpts = opts ? Object.assign({}, opts) : {};
    if (!nextOpts.action) nextOpts.action = 'cart-update';
    return cartMutate('/cart/update.js', body, nextOpts);
  }

  function runExternalJobWithTimeout(job) {
    var timeoutMs = typeof job.timeoutMs === 'number' && job.timeoutMs > 0 ? job.timeoutMs : 15000;
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        var timeoutErr = new Error('External mutation timed out (' + timeoutMs + 'ms)');
        timeoutErr.code = 'EXTERNAL_TIMEOUT';
        reject(timeoutErr);
      }, timeoutMs);
      Promise.resolve().then(function () { return job.run(); })
        .then(function (result) { if (settled) return; settled = true; clearTimeout(timer); resolve(result); })
        .catch(function (err) { if (settled) return; settled = true; clearTimeout(timer); reject(err); });
    });
  }

  function performExternalMutation(job) {
    var startedAt = Date.now();
    var timeoutMs = typeof job.timeoutMs === 'number' && job.timeoutMs > 0 ? job.timeoutMs : 15000;
    debugLog('external:start', { action: job.action || job.label || 'external-mutate', endpoint: job.endpoint || '/cart/external', timeoutMs: timeoutMs, queuedRemaining: _queue.length });
    Promise.resolve()
      .then(function () {
        if (typeof job.run !== 'function') throw new Error('External mutation job missing run()');
        var endpoint = job.endpoint || '/cart/external';
        var action = job.action || job.label || 'external-mutate';
        function runAttempt(retry) {
          var source = retry > 0 ? 'external-queue-retry' : 'external-queue';
          recordRequest(endpoint, action, source);
          return runExternalJobWithTimeout(job).catch(function (err) {
            if (!isRateLimitError(err) || retry >= 2) throw err;
            return sleep(650 * (retry + 1)).then(function () {
              return runAttempt(retry + 1);
            });
          });
        }
        return runAttempt(0);
      })
      .then(function (result) {
        if (hasAuthoritativeCartShape(result)) markCartFresh(result);
        else if (job.invalidateFreshCart) invalidateFreshCartCache({ clearLatest: true });
        debugLog('external:success', { action: job.action || job.label || 'external-mutate', elapsedMs: Date.now() - startedAt, authoritative: hasAuthoritativeCartShape(result) });
        job.resolve(result);
      })
      .catch(function (err) {
        if (job.invalidateFreshCart) invalidateFreshCartCache({ clearLatest: true });
        window.__ddLastMutationError = { at: new Date().toISOString(), endpoint: job.endpoint || '/cart/external', action: job.action || job.label || 'external-mutate', body: null, message: err && err.message ? err.message : String(err) };
        debugLog('external:error', { action: job.action || job.label || 'external-mutate', elapsedMs: Date.now() - startedAt, message: err && err.message ? err.message : String(err), code: err && err.code ? err.code : null });
        console.error('[cart-queue] external mutation error (' + (job.label || 'unknown') + ')', err);
        job.reject(err);
      })
      .finally(function () { _processing = false; _activeJob = null; if (_queue.length) processQueue(); });
  }

  function enqueueExternalMutation(opts) {
    return queueMutate({
      run: opts && opts.run,
      label: (opts && opts.label) || 'external',
      requester: (opts && opts.requester) || 'external',
      endpoint: (opts && opts.endpoint) || '/cart/external',
      action: (opts && opts.action) || ((opts && opts.label) || 'external-mutate'),
      timeoutMs: (opts && typeof opts.timeoutMs === 'number') ? opts.timeoutMs : 15000,
      invalidateFreshCart: !opts || opts.invalidateFreshCart !== false,
      render: false,
      publish: false
    });
  }

  function ensureFreshCart(opts) {
    var maxAge = opts && typeof opts.maxAge === 'number' ? opts.maxAge : DEFAULT_CART_CACHE_TTL;
    if (maxAge < 0) maxAge = 0;
    var forceNetwork = !!(opts && opts.forceNetwork);
    if (_processing && !forceNetwork) {
      return waitForIdle(3000).then(function () {
        if (_latestCartData && hasAuthoritativeCartShape(_latestCartData)) return _latestCartData;
        return ensureFreshCart({ maxAge: maxAge, forceNetwork: true });
      });
    }
    if (!forceNetwork && _latestCartData && (Date.now() - _freshCartTs < maxAge)) return Promise.resolve(_latestCartData);
    if (_freshCartInflight) return _freshCartInflight;
    var requestRevision = _cartRevision;
    recordRequest('/cart.js', 'ensure-fresh-cart', forceNetwork ? 'force-network' : 'cache-miss');
    _freshCartInflight = fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('ensureFreshCart failed (' + r.status + ')'); return r.json(); })
      .then(function (cart) {
        if (_cartRevision > requestRevision) return hasAuthoritativeCartShape(_latestCartData) ? _latestCartData : cart;
        if (!markCartFresh(cart)) invalidateFreshCartCache({ clearLatest: true });
        return hasAuthoritativeCartShape(_latestCartData) ? _latestCartData : cart;
      })
      .finally(function () { _freshCartInflight = null; });
    return _freshCartInflight;
  }

  function waitForIdle(timeoutMs) {
    var limit = typeof timeoutMs === 'number' ? timeoutMs : 3500;
    return new Promise(function (resolve) {
      var started = Date.now();
      (function poll() {
        if (!_processing && _queue.length === 0) return resolve();
        if (Date.now() - started >= limit) return resolve();
        window.setTimeout(poll, 40);
      })();
    });
  }

  function getMetrics() { return JSON.parse(JSON.stringify(_metrics)); }

  function getMetricsSummary() {
    var keys = Object.keys(_metrics.coalescedByKey || {});
    var actions = Object.keys(_metrics.coalescedByAction || {});
    var topKey = '', topKeyCount = 0, topAction = '', topActionCount = 0;
    for (var i = 0; i < keys.length; i++) { var kc = Number(_metrics.coalescedByKey[keys[i]] || 0); if (kc > topKeyCount) { topKey = keys[i]; topKeyCount = kc; } }
    for (var j = 0; j < actions.length; j++) { var ac = Number(_metrics.coalescedByAction[actions[j]] || 0); if (ac > topActionCount) { topAction = actions[j]; topActionCount = ac; } }
    return { startedAt: _metrics.startedAt, requestsTotal: _metrics.requestsTotal, queueDrops: _metrics.queueDrops, coalescedKeys: keys.length, coalescedActions: actions.length, topCoalesceKey: topKey, topCoalesceKeyCount: topKeyCount, topCoalesceAction: topAction, topCoalesceActionCount: topActionCount };
  }

  function getQueueDebugState() {
    return {
      processing: _processing,
      activeJob: _activeJob ? { type: _activeJob.type || 'mutation', endpoint: _activeJob.endpoint || null, action: (_activeJob.opts && _activeJob.opts.action) || _activeJob.action || _activeJob.label || null } : null,
      queueLength: _queue.length,
      pendingActions: _queue.map(function (job) { return (job && ((job.opts && job.opts.action) || job.action || job.label)) || 'cart-mutate'; })
    };
  }

  function resetMetrics() {
    _metrics.requestsTotal = 0;
    _metrics.requestsByEndpoint = {};
    _metrics.requestsByAction = {};
    _metrics.recentRequests = [];
    _metrics.drawerPatchSuccess = 0;
    _metrics.drawerPatchFail = 0;
    _metrics.drawerFullReplaceFallback = 0;
    _metrics.queueDrops = 0;
    _metrics.coalescedByKey = {};
    _metrics.coalescedByAction = {};
  }

  window._ddCartQueue = {
    queueMutate: queueMutate,
    cartMutate: cartMutate,
    mutateCartChange: mutateCartChange,
    mutateCartUpdate: mutateCartUpdate,
    makeCoalesceKey: makeCoalesceKey,
    enqueueExternalMutation: enqueueExternalMutation,
    ensureFreshCart: ensureFreshCart,
    waitForIdle: waitForIdle,
    recordRequest: recordRequest,
    getMetrics: getMetrics,
    getMetricsSummary: getMetricsSummary,
    getQueueDebugState: getQueueDebugState,
    resetMetrics: resetMetrics,
    debugLog: debugLog,
    hasAuthoritativeCartShape: hasAuthoritativeCartShape,
    getLatestCart: getLatestCart,
    seedLatestCart: seedLatestCart,
    markCartFresh: markCartFresh,
    invalidateFreshCartCache: invalidateFreshCartCache
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cart = event && event.cartData;
      if (!cart) return;
      if (hasAuthoritativeCartShape(cart)) markCartFresh(cart);
    });
  }
})();
